<p-blockUI [blocked]="blocked">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>

<div class="grid fluid" *ngIf="false">

  <div class="col-6 xl:col-6 sm:col-12">
    <app-companyselector labelKey="Переместить на юрлицо" [parentCompany]="parentDocument.DOCMANCLIID" [selectedID]="newDocument.DOCLCOCLIID" (selectedCompanyID)="lcoCompanySelected($event)"></app-companyselector>
  </div>
  <div class="col-6 xl:col-6 sm:col-12">
    <app-departmentselector labelKey="Переместить на склад" [parentCompany]="newDocument.DOCPCOCLIID" [selectedID]="newDocument.DOCPCODEPID" (selectedDepartmentID)="mainStockSelected($event)"></app-departmentselector>
  </div>
</div>
